var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Instance',{attrs:{"instance":"contact","instance-name":"Contact","create":d => _vm.contactDetails.create(d),"delete":d => _vm.contactDetails.remove(d),"update":d => _vm.contactDetails.update(d),"get":d => _vm.contactDetails.get(d),"upsert":_vm.upsert,"details":_vm.details,"columns":_vm.columns,"hideDelete":!_vm.isCommonAdmin}})
}
var staticRenderFns = []

export { render, staticRenderFns }